export const DEFAULT_API_MAX_RETRIES = 3

const parseStatusCode = (value: unknown): number | undefined => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value)
    return Number.isFinite(parsed) ? parsed : undefined
  }

  return undefined
}

export const getApiErrorStatus = (error: any): number | undefined => {
  const status =
    parseStatusCode(error?.response?.status) ??
    parseStatusCode(error?.statusCode) ??
    parseStatusCode(error?.code) ??
    parseStatusCode(error?.status)

  if (status) return status

  if (error instanceof Error || typeof error?.message === 'string') {
    const match = error.message.match(/\b([45]\d{2})\b/)
    return match ? Number(match[1]) : undefined
  }

  return undefined
}

export const shouldRetryApiError = (error: any): boolean => {
  const status = getApiErrorStatus(error)

  if (status) {
    // Client-side request problems are not transient; 401 logs the user out
    // elsewhere, and 422 validation errors should surface immediately.
    if (status >= 400 && status < 500) return false
    if (status >= 500) return true
  }

  if (error?.code === 'ECONNABORTED') return true

  return !error?.response
}

export const createApiRetryHandler =
  (maxRetries: number = DEFAULT_API_MAX_RETRIES) =>
  (failureCount: number, error: any): boolean => {
    if (!shouldRetryApiError(error)) {
      return false
    }

    if (error && typeof error === 'object') {
      error._retryCount = failureCount
      error._maxRetries = maxRetries
    }

    return failureCount < maxRetries
  }
